/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Table, Button, notification, DatePicker, Select, Tag, Input } from 'antd';
import { SearchOutlined, DownloadOutlined } from '@ant-design/icons';
import { PageContainer } from '@ant-design/pro-layout';
import dayjs from 'dayjs';
import { AuthContext } from 'context/AuthContext';
import reportService from 'services/report.service';
import branchService from 'services/branch.service';
import { formatDateForClient, formatDateForServer, formatMoney } from 'helpers/utils';
import { storage } from 'helpers';
import download from 'js-file-download';
import 'antd/dist/reset.css';

const { RangePicker } = DatePicker;
const { Option } = Select;

const renderFilterDropdown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
  <div style={{ padding: 8 }}>
    <Input
      placeholder="Fatura No Ara"
      value={selectedKeys[0]}
      onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
      onPressEnter={() => confirm()}
      style={{ width: 188, marginBottom: 8, display: 'block' }}
    />
    <Button
      type="primary"
      onClick={() => confirm()}
      icon={<SearchOutlined />}
      size="small"
      style={{ width: 90, marginRight: 8 }}
    >
      Ara
    </Button>
    <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
      Temizle
    </Button>
  </div>
);

class MyInvoice extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      reports: [],
      branches: [],
      selectedBranch: '0',
      loading: false,
      startDate: formatDateForClient(dayjs().subtract(365, 'days')),
      endDate: formatDateForClient(),
      currentMerch: context?.selectedMerch,
      columns: [
        {
          title: <div className="table-title-calibri-bold-12">Fatura Durumu</div>,
          dataIndex: 'Invoice',
          align: 'center',
          key: 'Invoice',
          width: 50,
          render: (text, row) => (
            <div style={{ textAlign: 'center' }}>
              <span className="table-title-calibri-bold-12">{row.agreemenStatusName}</span> <br />{' '}
              <span className="table-content-calibri-light-10">
                Takip No: {row.TakipNo} - Slip Tarihi:{' '}
                {row.FaturaKesSlipTarihi ? dayjs(row.FaturaKesSlipTarihi).format('DD.MM.YYYY') : ''}
              </span>
            </div>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Şube Bilgisi</div>,
          dataIndex: 'Branch',
          align: 'center',
          key: 'Branch',
          width: 50,
          render: (text, row) => (
            <div style={{ textAlign: 'center' }}>
              <span className="table-title-calibri-bold-12">{row.BranchName}</span>{' '}
              <span className="table-title-calibri-bold-12">{row.BranchId}</span> <br />
              <span className="table-content-calibri-light-10">
                Fatura Kesme Yöntemi: {row.SubeOrMerkez}
              </span>
            </div>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Fatura Tarihi / Numarası</div>,
          dataIndex: 'InvoiceDateAndNo',
          key: 'InvoiceDateAndNo',
          align: 'center',
          width: 50,
          onFilter: (value, record) => record?.InvoiceNumber?.toString()?.indexOf(value) === 0,
          filterDropdown: renderFilterDropdown,
          render: (text, row) => (
            <div>
              <span className="table-title-calibri-bold-12">
                {row.InvoiceDate ? dayjs(row.InvoiceDate).format('DD.MM.YYYY') : '?'}
              </span>
              <br />
              <span className="table-title-calibri-bold-12">{row.InvoiceNumber}</span>
            </div>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Fatura Tutarı</div>,
          dataIndex: 'InvoiceAmount',
          key: 'InvoiceAmount',
          align: 'center',
          width: 50,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.InvoiceAmount ? formatMoney(row.InvoiceAmount) : '?'} TL
            </span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Ödeme Tarihi / Durumu</div>,
          dataIndex: 'PaymentDate',
          align: 'center',
          key: 'PaymentDate',
          width: 50,
          render: (text, row) => (
            <div>
              <span className="table-title-calibri-bold-12">
                {row.paymentProcessStatusName ? row.paymentProcessStatusName : ' '}
              </span>
              <br />{' '}
              <span className="table-title-calibri-bold-12">
                {row.PaymentDate ? dayjs(row.PaymentDate).format('DD.MM.YYYY') : '?'}{' '}
              </span>
            </div>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Hakediş Tutarı</div>,
          dataIndex: 'HakedisAmount',
          key: 'HakedisAmount',
          align: 'center',
          width: 50,
          render: (text, row) => (
            <span className="table-title-calibri-bold-16">
              {row.HakedisAmount ? formatMoney(row.HakedisAmount) : '?'} TL
            </span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Fatura Durumu</div>,
          dataIndex: 'InvoiceStatus',
          key: 'InvoiceStatus',
          align: 'center',
          width: 70,
          render: (InvoiceStatus, record) => {
            return (
              <Tag
                color={InvoiceStatus === 'Ödeme Gönderildi' ? 'green' : 'volcano'}
                key={record?.identifier}
              >
                {InvoiceStatus}
              </Tag>
            );
          },
        },
        {
          title: (
            <div style={{ textAlign: 'center' }} className="table-title-calibri-bold-12">
              Faturaya Ait Günsonu Raporu
            </div>
          ),
          dataIndex: 'ReportUrl',
          key: 'ReportUrl',
          align: 'center',
          width: 50,
          render: (text, record) => (
            <div>
              <Button
                loading={this.state.downloading === record.FaturaId}
                key="download"
                type="primary"
                icon={<DownloadOutlined />}
                className="mr-3"
                onClick={async () => {
                  try {
                    this.setState({ downloading: record.FaturaId });
                    const { currentMerch, startDate, endDate } = this.state;
                    const clientId = 0;
                    const data = await reportService.getEodReportsByAgreementIdExcel(
                      currentMerch?.number,
                      formatDateForServer(startDate),
                      formatDateForServer(endDate),
                      record?.BranchId,
                      clientId,
                      record?.TakipNo,
                    );
                    download(
                      data,
                      `FaturayaAitGünSonu-${currentMerch?.number}-${dayjs().format(
                        'DD-MM-YYYY',
                      )}.xls`,
                    );
                    this.setState({ downloading: false });
                  } catch (error) {
                    this.setState({ downloading: false });
                    notification.error({
                      message: 'İşlem Başarısız',
                      description: error,
                    });
                  }
                }}
              >
                <span>İndir</span>
              </Button>
            </div>
          ),
        },
      ],
    };
  }

  componentDidMount() {
    this.getReports();
    this.getCurrentMerchBranches();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState?.currentMerch?.number !== this.context?.selectedMerch?.number &&
      this.state?.currentMerch?.number === prevState.currentMerch?.number
    ) {
      this.getReports();
      this.getCurrentMerchBranches();
    }
  }

  getReports = () => {
    this.setState({ loading: true, currentMerch: this.context?.selectedMerch }, async () => {
      try {
        const { currentMerch, endDate, startDate, selectedBranch } = this.state;
        if (currentMerch?.number) {
          const { payload } = await reportService.getMyInvoicesReports(
            currentMerch?.number,
            formatDateForServer(startDate),
            formatDateForServer(endDate),
            selectedBranch,
          );
          this.setState({ loading: false, reports: payload });
        }
      } catch (error) {
        this.setState({ loading: false, reports: [] });
        notification.error({
          message: 'İşlem Başarısız',
          description: error,
        });
      }
    });
  };

  getCurrentMerchBranches = async () => {
    try {
      await this.setState({ loading: true, currentMerch: this.context?.selectedMerch });
      const number = this.context?.selectedMerch?.number;
      if (number) {
        const { payload } = await branchService.getBranchesByMerch(number);
        this.setState({ loading: false, branches: payload });
      }
    } catch (error) {
      this.setState({ loading: false });
      notification.error({
        message: 'İşlem Başarısız',
        description: error,
      });
    }
  };

  onDateChange = (dates) => {
    if (!dates || dates.length !== 2) return;
    const startDate = formatDateForClient(dates[0]);
    const endDate = formatDateForClient(dates[1]);
    this.setState({ startDate, endDate }, () => {
      storage.set({ startDate, endDate }, 'date-filters');
      this.getReports();
    });
  };

  onBranchChange = (selectedBranch) => {
    this.setState({ selectedBranch }, () => {
      storage.set({ selectedBranch }, 'branch-filters');
      this.getReports();
    });
  };

  renderBranchOptions = () => {
    const { branches } = this.state;
    return branches?.map((branch) => (
      <Option key={branch.BranchId} value={branch.BranchId}>
        {branch.BranchTitle}
      </Option>
    ));
  };

  downloadExcel = async () => {
    try {
      this.setState({ loading: true });
      const { currentMerch, startDate, endDate, selectedBranch } = this.state;
      const data = await reportService.getMyInvoicesReportsExcel(
        currentMerch?.number,
        formatDateForServer(startDate),
        formatDateForServer(endDate),
        selectedBranch,
      );
      download(data, `Faturalarim-${currentMerch?.number}-${dayjs().format('DD-MM-YYYY')}.xls`);
      this.setState({ loading: false });
    } catch (error) {
      this.setState({ loading: false });
      notification.error({
        message: 'İşlem Başarısız',
        description: error,
      });
    }
  };

  render() {
    const { reports, columns, loading, startDate, endDate, branches } = this.state;
    return (
      <PageContainer
        title="Tarafımdan Kesilen Faturalar"
        extra={[
          <RangePicker
            allowClear={false}
            defaultValue={[dayjs(startDate, 'DD.MM.YYYY'), dayjs(endDate, 'DD.MM.YYYY')]}
            key="eod"
            onChange={this.onDateChange}
            format="DD.MM.YYYY"
          />,
          <Select
            key="branch"
            loading={branches.length === 0}
            defaultValue={0}
            onChange={this.onBranchChange}
            style={{ width: 200 }}
          >
            <Option value={0} key="ALL">
              Tüm Şubeler
            </Option>
            {this.renderBranchOptions()}
          </Select>,
          <Button
            loading={loading}
            disabled={loading}
            key="download"
            type="primary"
            icon={<DownloadOutlined />}
            onClick={() => {
              this.downloadExcel();
            }}
          >
            İndir
          </Button>,
        ]}
      >
        <Table
          dataSource={reports}
          columns={columns}
          pagination={false}
          rowKey={(record, index) => index}
        />
      </PageContainer>
    );
  }
}

MyInvoice.contextType = AuthContext;

const MyInvoiceWrapper = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  return <MyInvoice {...props} navigate={navigate} params={params} />;
};

export default MyInvoiceWrapper;
